<template>
  <div class="p-3 card">
    <label class="titlePage">Provas Especiais</label>
    <table class="table table-bordered table-condensed table-striped table-hover relatorio">
      <tr>
        <th scope="col" class="col-4">Importado</th>
        <th scope="col" class="col-4">Técnico</th>
        <th scope="col" class="col-4">Data</th>
        <th scope="col" class="col-4">Total de Registros</th>
      </tr>
      <tr v-if="provasEspeciais[0]">
        <td>{{ provasEspeciais[0].importado }}</td>
        <td>{{ provasEspeciais[0].tecnico }}</td>
        <td>{{ provasEspeciais[0].datainsert }}</td>
        <td>{{ provasEspeciais[0].totalregistro }}</td>
      </tr>
    </table>
    <div class="text-right mb-3">
      <fcc-button @click="() => $emit('importar')" class="mr-2">Importar</fcc-button>
      <fcc-button @click="() => $emit('excluir')">{{ labelsSystem.excluir }}</fcc-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['provas-especiais']
}
</script>